import { useState, useEffect } from 'react';

interface BotStats {
  servers: number;
  members: number;
  messages: number;
  commands: number;
  uptime: number;
  responseTime: number;
  botStatus: {
    online: boolean;
    guilds: number;
    users: number;
  };
}

export const useStats = () => {
  const [stats, setStats] = useState<BotStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const apiUrl = import.meta.env.VITE_API_URL || 'https://api.nativeit-botds.it';
        const response = await fetch(`${apiUrl}/api/stats`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch statistics');
        }

        const data = await response.json();
        setStats(data);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching stats:', err);
        setError(err.message);
        // Set fallback stats in case of error
        setStats({
          servers: 0,
          members: 0,
          messages: 0,
          commands: 0,
          uptime: 0,
          responseTime: 0,
          botStatus: {
            online: false,
            guilds: 0,
            users: 0,
          }
        });
      } finally {
        setLoading(false);
      }
    };

    fetchStats();

    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);

    return () => clearInterval(interval);
  }, []);

  return { stats, loading, error };
};
